import { useAppTheme } from "@hooks/useAppTheme";
import { Box, Container, Loader, useDevice } from "@memorang/ui";
/* -----------------UI--------------- */
import { Card } from "react-native-paper";
import useLeaderboard from "../hooks/useLeaderboard";
import useUserLeaderboard from "../hooks/useUserLeaderboard";

/* -----------------Child components--------------- */
import LeaderboardView from "../components/Leaderboard/LeaderboardView";

const LeaderboardContainer = () => {
	const {
		leaderboards,
		podiumData,
		selectedChip,
		handleSelectChip,
		fetchingLeaderboard,
	} = useLeaderboard();

	const { isMobile } = useDevice();
	const { userLeaderboardResponse } = useUserLeaderboard(selectedChip);

	const theme = useAppTheme();
	const Wrapper = isMobile ? Box : Card;

	if (fetchingLeaderboard || !leaderboards || !userLeaderboardResponse) {
		return <Loader />;
	}

	return (
		<Container
			style={{
				paddingHorizontal: isMobile ? 0 : 16,
				paddingVertical: isMobile ? 0 : 16,
			}}
		>
			<Wrapper style={{ backgroundColor: theme.colors.background }}>
				<LeaderboardView
					userLeaderboardItem={userLeaderboardResponse}
					leaderboards={leaderboards}
					topRankers={podiumData}
					selectedChip={selectedChip}
					handleSelectChip={handleSelectChip}
					avatarType={"initials"}
				/>
			</Wrapper>
		</Container>
	);
};

export default LeaderboardContainer;
